export const Wrapper =
  'flex flex-row border-machine2-75 border h-12 w-[110px] select-none text-black fill-black justify-between items-center rounded-sm bg-white'

export const IconWrapper = 'w-9 shrink-0 h-full px-2'

export const IconDisabled = `${IconWrapper} text-gray214 cursor-not-allowed`

export const IconClickable = `${IconWrapper} cursor-pointer`

export const QuantityDisplay =
  'border-machine2-75 border-l border-r py-3 text-16 w-9 shrink-0 h-full text-center'
